export interface SkeletonProps {
  className?: string;
  /** Si présent, contrôle l'arrondi (sinon rounded-md) */
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

/** Bloc neutre pulsant pendant un chargement IA. */
export const Skeleton = ({ className = '', rounded = 'md' }: SkeletonProps) => (
  <div
    aria-hidden="true"
    className={[
      'skeleton',
      `rounded-${rounded}`,
      className,
    ].filter(Boolean).join(' ')}
  />
);

/** Skeleton multi-lignes pour un bloc de texte (ex : tip, conseil IA). */
export const SkeletonLines = ({ count = 3, className = '' }: { count?: number; className?: string }) => (
  <div className={['space-y-2', className].filter(Boolean).join(' ')} aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} className={`h-3 ${i === count - 1 ? 'w-2/3' : 'w-full'}`} />
    ))}
  </div>
);
